const headerTitle = {
  type: 'Heading',
  name: 'A1',
  fontWeight: '400',
  letter: 'normal',
  fontSize: '18px',
  lineHeight: '27px'
}

const desktopHeaderTitle = {
  type: 'Heading',
  name: 'A1',
  fontWeight: '400',
  letter: 'normal',
  fontSize: '18px',
  lineHeight: '27px'
}

const headerDescription = {
  type: 'Label',
  name: '1',
  fontWeight: '400',
  letter: 'none',
  fontSize: '20px',
  lineHeight: '25px',
  desktopFontSize: '14px',
  desktopLineHeight: '17.5px'
}

const contentDescription = {
  type: 'Label',
  name: '3',
  fontWeight: '325',
  letter: '0.18px',
  fontSize: '18px',
  lineHeight: '22.5px',
  desktopFontSize: '18px',
  desktopLineHeight: '22.5px'
}

const benefitCardTitle = {
  type: 'Heading',
  name: 'A2',
  fontWeight: '400',
  letter: 'normal',
  fontSize: '16px',
  lineHeight: '24px',
  desktopFontSize: '16px',
  desktopLineHeight: '24px'
}

const benefitCardDescription = {
  type: 'Paragraph',
  name: '3',
  fontWeight: '400',
  fontSize: '22px',
  lineHeight: '33px',
  desktopFontSize: '14px',
  desktopLineHeight: '21px'
}

export default {
  headerTitle,
  headerDescription,
  contentDescription,
  benefitCardTitle,
  benefitCardDescription,
  desktopHeaderTitle
}
